<template>
  <div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="isLoadedNormal && deviceTokenInfo !== null">
      <table
        class="prop-table mb-4"
      >
        <tr>
          <th>Язык</th>
          <td>{{deviceTokenInfo.lang | getLangNameEn}}</td>
        </tr>
        <tr>
          <th>Utc delta</th>
          <td>{{deviceTokenInfo.utcDelta | getSignedNumberStr}}</td>
        </tr>
        <tr>
          <th>Платформа</th>
          <td>{{deviceTokenInfo.platform | getPlatformName}}</td>
        </tr>
        <tr>
          <th>Версия</th>
          <td>{{deviceTokenInfo.clientVersionCode | convertVersionCodeToStr}}</td>
        </tr>
        <tr>
          <th>Сохранение</th>
          <td>{{ saveTimeStr }}</td>
        </tr>
      </table>

      <p class="prop-lable">Device token</p>
      <p class="device-token mb-4">
        {{deviceTokenInfo.deviceToken}}
      </p>

      <b-button
        v-if="isEditButtonVisible"
        :to="{name: 'player_device_token_info_edit', params: {playerId: playerId}}"
      >
        Edit
      </b-button>
    </template>

    <loading-indicator v-if="isLoading"/>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

/**
 * @typedef { import('../model/push.js').DeviceTokenInfo } DeviceTokenInfo
 */

import auth from '../auth.js';
import { isRoleAdmin  } from '../util.js';
import { getMomentStr } from '../util.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerDeviceTokenInfo',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,

      /** @type {?DeviceTokenInfo} */
      deviceTokenInfo: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoadedNormal && this.deviceTokenInfo === null) {
        return 'No device token info.';
      }
      return null;
    },

    saveTimeStr() {
      return getMomentStr(this.deviceTokenInfo.mtime);
    },

    /** @returns {boolean} */
    isEditButtonVisible() {
      return this.mayManage;
    },

    /** @returns {boolean} */
    mayManage() {
      const actor = this.actor;
      if(actor === null) {
        throw new Error('actor === null');
      }

      return isRoleAdmin(actor.role);
    },
  },

  created() {
    this.loadDeviceTokenInfo();
  },

  methods: {
    loadDeviceTokenInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/device_token_info`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        this.deviceTokenInfo = data;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
  .device-token {
    word-break: break-all;
    font-family: monospace;
  }
</style>
